import { render, staticRenderFns } from "./profile-change-password.vue?vue&type=template&id=e8f94530&"
import script from "./profile-change-password.vue?vue&type=script&lang=js&"
export * from "./profile-change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports